// Separate local-device scope. Never store this credential in URLs or persistent storage.
let active = false;
let session: {csrf:string; expires:number} | null = null;
let pending: Promise<void> | null = null;
const id = '[A-Za-z0-9_-]{1,160}';
const localPaths = new RegExp(`^(?:/local-device/devices|/devices/refresh|/devices/${id}/(?:manual-control|input-component|manual-action|manual-takeover/(?:start|end)|manual-input-session(?:/${id})?)|/phone-workspace/${id}/(?:prepare|test|recover))$`);
export function setLocalDeviceAccess(value:boolean) { active=value; }
export async function ensureLocalDeviceSession():Promise<void> {
  if(session && session.expires>Date.now()+30_000)return;
  if(!pending)pending=(async()=>{
    const response=await fetch('/api/local-device/session',{method:'POST',credentials:'same-origin',cache:'no-store',
      headers:{'X-Local-Device-Bootstrap':'1'}});
    if(!response.ok)throw new Error('无法建立本机设备会话，请从本机软件窗口打开。');
    const value=await response.json() as {csrf:string;expires_in:number;scope:string};
    if(value.scope!=='local_device'||!value.csrf||!Number.isFinite(value.expires_in))throw new Error('本机会话未确认');
    session={csrf:value.csrf,expires:Date.now()+value.expires_in*1000};
  })().finally(()=>{pending=null;});
  return pending;
}
export async function localDeviceHeaders(path:string):Promise<Record<string,string>> {
  if(!active||!localPaths.test(path.split('?')[0]))return {};
  await ensureLocalDeviceSession();
  return {'X-Local-Device-CSRF':session!.csrf};
}
export interface LocalPhone {id:string;name:string;serial:string;runtime:'native';status:'online'|'offline'|'unauthorized'|'error';manual_generation:string|null;manual_epoch:string|null;}
export async function localPhones():Promise<LocalPhone[]> {
  const response=await fetch('/api/local-device/devices',{cache:'no-store',headers:await localDeviceHeaders('/local-device/devices')});
  if(!response.ok)throw new Error('无法读取本机手机连接，请重新打开本机入口。');
  return response.json();
}
